import {useState, useEffect} from "react"
import ClientsGrid from "./ClientsGrid"
import ConfirmModal from '../../components/Modal/ConfirmModal'
import {deleteClient, addClient, updateClient} from "../../api/clients"
import { toaster } from '../../helpers/toaster'
import ClientDetailModal from "./ClientDetailModal"
import { Search, Button } from 'carbon-components-react'

const useClientsGrid = (
  {isStudyDetail, clientlist, setStudyDetails} = {}
) => {
  const [clientLoading, setClientLoading] = useState(false)
  const [detailModalMode, setDetailModalMode] = useState(false)
  const [clientId, setClientId] = useState(null)
  const [clientData, setClientData] = useState(null)
  const [openClientModal, setOpenClientModal] = useState(false)
  const [searchGrid, setSearchGrid] = useState("")
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [deleteItemId, setDeleteItemId] = useState(null)
  const [refreshData, setRefreshData] = useState(false)
  const [sort, setSort] = useState("")
  const [search, setSearch] = useState("")

  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px"
  }


  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search)
    }, 500)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search])


  const openCreateClientModal = () => {
    setDetailModalMode("create")
    setClientData(null)
    setOpenClientModal(true)
  }


  const clientRowClicked = (data) => {
    setDetailModalMode("update")
    setClientId(data.id)
    setClientData(data)
    setOpenClientModal(true)
  }

  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true)
    setDeleteItemId(itemId)
  }

  const confirmDelete = () => {
    setClientLoading(true)
    deleteClient(deleteItemId).then(res => {
      setRefreshData(true)
      setClientLoading(false)
      toaster("Client deleted successfully", "success")
      setOpenDeleteModal(false)
    })
  }

  const confirmSave = (regInfo) => {
    setClientLoading(true);
    return addClient(regInfo).then(res => {

      // for clients list page
      setRefreshData(true)
      toaster("Client created successfully", "success")
      setClientLoading(false);
      setOpenClientModal(false)
      return res.data
    }).catch(error => {
      toaster("Failed to create client", "error")
      setClientLoading(false);
      setOpenClientModal(false)
    });

  }

  const confirmUpdate = (clientIndex, clientInfo) => {
    setClientLoading(true);
    return updateClient(clientIndex, clientInfo).then(res => {

      // for clients list page
      setRefreshData(true)

      toaster("Client updated successfully", "success")
      setClientLoading(false);
      setOpenClientModal(false)
      return res.data
    }).catch(error => {
      toaster("Failed to update client", "error")
      setClientLoading(false);
      setOpenClientModal(false)
    });

  }

  const addClientButton = () => {
    return <Button
      kind="primary"
      onClick={() => openCreateClientModal()}
      style={addBtnStyle}
    >Add Client
    </Button>
  }

  const clientSearch = () => {
    return <div style={{ width: "300px" }}>
      <Search
        size="sm"
        value={search}
        labelText="search"
        onChange={e => setSearch(e.target.value)}
        placeHolderText="Search using any data value" />
    </div>
  }


  const clientsGrid = () => {
    return (
      <div>
        <ClientsGrid
          onRowClicked={clientRowClicked}
          search={searchGrid}
          onDeleteClicked={showDeleteConfirm}
          setRefresh={setRefreshData}
          refresh={refreshData}
          sort={sort}
          setSort={setSort}
        />

        <ClientDetailModal
          mode={detailModalMode}
          clientIndex={clientId}
          open={openClientModal}
          clientData={clientData}
          onClose={() => setOpenClientModal(false)}
          confirmSave={confirmSave}
          confirmUpdate={confirmUpdate}
          clientLoading={clientLoading}
          setClientLoading={setClientLoading}
        />

        <ConfirmModal
          title="Confirmation"
          content="Are you sure you want to delete this client?"
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          onConfirm={() => confirmDelete()}
        />

      </div>

    );
  }

  return {
    addClientButton,
    clientSearch,
    clientsGrid,
    clientLoading,
    setClientLoading,
  }
}

export default useClientsGrid;
